export default {
  oopsHeader: 'Please Contact Us',
  buttonText: 'OK',
  defaultMessage: 'Oops! The link you just clicked on is temporarily unavailable. Please close this window and try again.',
};
